import React, { Fragment, useState } from "react"
import { Box, styled } from "@mui/material"

import PlanStandard from "components/Subscription/Plan/CardStandard"
import PlanSilver from "components/Subscription/Plan/CardSilver"
import PlanGold from "components/Subscription/Plan/CardGold"
import {
  SUBSCRIPTION_CREATE_TYPE,
  PLAN_STANDARD,
  PLAN_SILVER,
  PLAN_GOLD,
  PLAN_PERIOD_MONTH,
} from "config"
import {
  PlanOptionType,
  PlanListType,
  PlanNameType,
  SubscriptionType,
} from "types"

type Props = {
  items: PlanListType
  subscriptionType?: string
  activePlanType?: string
  disabledPlans?: string[]
  chosen?: PlanNameType
  subscription?: SubscriptionType
  onChoose: (plan: PlanOptionType) => void
}

const List = ({
  items,
  activePlanType,
  disabledPlans,
  chosen,
  onChoose,
}: Props) => {
  const [selectedPeriod, selectPeriod] = useState(PLAN_PERIOD_MONTH)

  const planStandard = items.find(
    ({ plan_type }) => plan_type === PLAN_STANDARD,
  )
  const planSilver = items.find(({ plan_type }) => plan_type === PLAN_SILVER)
  const planGold = items.find(({ plan_type }) => plan_type === PLAN_GOLD)

  // for upgrade we need know only about standard and silver
  let isStandardDisabled = false
  let isSilverDisabled = false

  if (disabledPlans) {
    isStandardDisabled = disabledPlans.indexOf(PLAN_STANDARD) >= 0
    isSilverDisabled = disabledPlans.indexOf(PLAN_SILVER) >= 0
  }

  const handleToggle = (period: string) => {
    selectPeriod(period)
  }

  const handleChoosePlan = (plan: PlanOptionType) => {
    onChoose(plan)
  }

  return (
    <Container data-testid="plans-list">
      <Fragment>
        {planStandard && (
          <PlanStandard
            active={activePlanType === PLAN_STANDARD}
            disabled={isStandardDisabled}
            plan={planStandard}
            chosen={chosen}
            selectedPeriod={selectedPeriod}
            onToggle={handleToggle}
            onSubscribe={handleChoosePlan}
          />
        )}
        {planSilver && (
          <PlanSilver
            active={activePlanType === PLAN_SILVER}
            disabled={isSilverDisabled}
            plan={planSilver}
            chosen={chosen}
            selectedPeriod={selectedPeriod}
            onToggle={handleToggle}
            onSubscribe={handleChoosePlan}
          />
        )}
        {planGold && (
          <PlanGold
            active={activePlanType === PLAN_GOLD}
            disabled={false}
            plan={planGold}
            chosen={chosen}
            selectedPeriod={selectedPeriod}
            onToggle={handleToggle}
            onSubscribe={handleChoosePlan}
          />
        )}
      </Fragment>
    </Container>
  )
}

export default List

List.defaultProps = {
  subscriptionType: SUBSCRIPTION_CREATE_TYPE,
}

const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "nowrap",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "stretch",
  margin: "42px 0 8px 0",
  [theme.breakpoints.down("lg")]: {
    flexWrap: "wrap",
    flexDirection: "column",
  },
}))
